import { Validator } from '@vista-digital/validator';
import { defaultHeroAttributeColours, heroAttributeColoursValidator } from '../../../../types/hero-attribute-colours';
export const defaultOccShowtimeConfig = {
    heroAttributeColours: defaultHeroAttributeColours
};
export const occShowtimeConfigValidator = Validator.object({
    heroAttributeColours: heroAttributeColoursValidator
});
//# sourceMappingURL=showtime.js.map